/* eslint-disable arrow-body-style */
import React, { FC, PropsWithChildren } from 'react';

export const FilterPanel: FC<PropsWithChildren> = ({ children }) => (
  <div id="filterPanel">{children}</div>
);
